import React from 'react';
import {
  Box,
  Grid,
  alpha,
  Typography
} from '@mui/material';
import {
  Settings as SettingsIcon
} from '@mui/icons-material';

import InformacoesEstabelecimento from './InformacoesEstabelecimento';
import OpcoesImpressao from './OpcoesImpressao';

const ImpressoraConfig = ({ 
  configuracoes, 
  handleChange, 
  customTheme, 
  imprimirTeste, 
  imprimirTesteQrCode,
  testeEnviado,
  templateOptions = []
}) => {
  // Registrar quando o componente é atualizado com novas configurações
  React.useEffect(() => {
    console.log('ImpressoraConfig atualizado com novas configurações');
  }, [configuracoes]);

  return (
    <Box 
      sx={{ 
        border: '1px solid',
        borderColor: alpha(customTheme.palette.divider, 0.1),
        borderRadius: 3,
        p: 3,
        bgcolor: 'background.paper'
      }}
    >
      {/* Cabeçalho da seção */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        mb: 3,
        color: customTheme.palette.primary.main
      }}>
        <SettingsIcon sx={{ mr: 1 }} />
        <Typography variant="h6" fontWeight={600}>
          Configurações Básicas do Ticket
        </Typography>
      </Box>

      {/* Configurações em uma única tela */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <InformacoesEstabelecimento 
            configuracoes={configuracoes} 
            handleChange={handleChange} 
            customTheme={customTheme} 
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <OpcoesImpressao 
            configuracoes={configuracoes}
            handleChange={handleChange}
            customTheme={customTheme}
            imprimirTeste={imprimirTeste}
            imprimirTesteQrCode={imprimirTesteQrCode}
            testeEnviado={testeEnviado}
            templateOptions={templateOptions}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ImpressoraConfig; 